import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";

import AppContainer from "./AppContainer.jsx";
import { store, history } from "./store";
import regeneratorRuntime from "regenerator-runtime";
import "normalize.css";
import "./mobile.styl";

window.jsLoaded = true;
window.mobile = true;
console.log("Release: ", __webpack_hash__); // eslint-disable-line no-undef
const captureError = async error => {
	const { logError } = await import(
		/* webpackChunkName: "sentry" */ "./sentry"
	);
	logError(error);
};
window.onerror = (message, url, line, column, error) => captureError(error);
window.onunhandledrejection = event => captureError(event.reason);

if (/mobile/i.test(navigator.userAgent) && !window.location.hash) {
	setTimeout(() => {
		window.scrollTo(0, 1);
	}, 1000);
}

render(
	<Provider store={store}>
		<ConnectedRouter history={history}>
			<AppContainer />
		</ConnectedRouter>
	</Provider>,
	document.getElementById("app")
);
